import { render, staticRenderFns } from "./problemOfGoods-element.vue?vue&type=template&id=4fb671e8&scoped=true&"
import script from "./problemOfGoods-element.vue?vue&type=script&lang=js&"
export * from "./problemOfGoods-element.vue?vue&type=script&lang=js&"
import style0 from "./problemOfGoods-element.vue?vue&type=style&index=0&id=4fb671e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb671e8",
  null
  
)

export default component.exports